/**
 * WebSocket event names used throughout the application
 */
export const TASK_EVENTS = {
  CREATED: 'task:created',
  UPDATED: 'task:updated',
  DELETED: 'task:deleted',
  COMMENT_NOTIFICATION: 'task:comment:notification',
  COMMENT_ADDED: 'comment:added',
  MARKED_DONE: 'task:marked:done',
  UNMARKED_DONE: 'task:unmarked:done',
  VIEWED: 'task:viewed'
} as const;

export const CHAT_EVENTS = {
  MESSAGE: 'chat:message',
  TYPING: 'chat:typing',
  STOP_TYPING: 'chat:stop_typing'
} as const;

/**
 * Role-based notification configuration
 */
export const notificationConfig = {
  admin: {
    events: [
      TASK_EVENTS.CREATED,
      TASK_EVENTS.UPDATED,
      TASK_EVENTS.DELETED,
      TASK_EVENTS.COMMENT_NOTIFICATION,
      TASK_EVENTS.COMMENT_ADDED,
      CHAT_EVENTS.MESSAGE
    ],
    showBrowserNotifications: true,
    playSound: true,
    toastDuration: 10000 // 10 seconds
  },
  bureau: {
    events: [
      TASK_EVENTS.CREATED,
      TASK_EVENTS.UPDATED,
      TASK_EVENTS.DELETED,
      TASK_EVENTS.COMMENT_NOTIFICATION,
      TASK_EVENTS.COMMENT_ADDED,
      CHAT_EVENTS.MESSAGE
    ],
    showBrowserNotifications: true,
    playSound: true,
    toastDuration: 10000
  },
  expert: {
    events: [
      TASK_EVENTS.CREATED,
      TASK_EVENTS.UPDATED,
      TASK_EVENTS.DELETED,
      TASK_EVENTS.COMMENT_NOTIFICATION,
      TASK_EVENTS.COMMENT_ADDED,
      CHAT_EVENTS.MESSAGE
    ],
    showBrowserNotifications: true,
    playSound: true,
    toastDuration: 10000
  },
  client: {
    events: [], // Clients don't receive task notifications
    showBrowserNotifications: false,
    playSound: false,
    toastDuration: 10000
  },
  banque: {
    events: [], // Bank users don't receive task notifications
    showBrowserNotifications: false,
    playSound: false,
    toastDuration: 10000
  }
} as const;

export type UserRole = keyof typeof notificationConfig;
export type TaskEventType = typeof TASK_EVENTS[keyof typeof TASK_EVENTS];
export type ChatEventType = typeof CHAT_EVENTS[keyof typeof CHAT_EVENTS];